import { useNavigate } from 'react-router-dom';
import { Container, Grid } from '@mui/material';
import logo from '../../assets/images/header/Logo.svg';
import './styles.scss';

export default function ErrorPublica() {
	const navigate = useNavigate();

	let backgroundStyles = '';
	backgroundStyles += `#root::after {background-color: #fff }`;
	return (
		<>
			<style>{backgroundStyles}</style>
			<div id='error'>
				<div className='header'>
					<img src={logo} alt='logo' />
				</div>
				<Container maxWidth='lg' style={{ marginBottom: '40px' }}>
					<Grid container justifyContent='center' alignItems='center' spacing={4}>
						<Grid item xs={12} sm={7} md={7} lg={7}>
							<h1 className='titulo-encuesta'>¡Oooops!</h1>
							<h1 className='titulo-encuesta'>Página no encontrada</h1>
						</Grid>
						<Grid item xs={12} sm={7} md={7} lg={7}>
							<div className='btn-iniciar' onClick={() => navigate('/')}>
								Regresar
							</div>
						</Grid>
					</Grid>
				</Container>
			</div>
		</>
	);
}
